import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../components/CiscoUi';
import { NotifyPanel } from '../../../components';

export function GenericError(): ReactElement {
  const history = useHistory();

  return (
    <NotifyPanel
      callToAction={
        <Button
          className="base-margin-top base-margin-bottom"
          colour="success"
          onClick={() => history.push('/')}
          size="large"
          testId="generic-error-page-cta"
        >
          Return to Topology Builder
        </Button>
      }
      heading="Topology Builder"
      subHeading="Sorry, something went wrong. Please try again"
    />
  );
}
